import React from 'react';
import { Mail, Phone } from 'lucide-react';
import './Directory.css';

const Directory = () => {
  const departments = [
    {
      name: 'Executive Leadership',
      employees: [
        {
          name: 'Aaron Gregory',
          title: 'Founder/Owner/CEO',
          phone: '(434) 321-7302',
          email: 'aaron.gregory@agwesternrail.com'
        },
        {
          name: 'Jennifer Major',
          title: 'Chief Human Resource Officer',
          phone: '(804) 339-5832',
          email: 'Jennifer.Major@agwesternrail.com'
        }
      ]
    }
  ];

  return (
    <div className="directory-page">
      {/* Hero Section */}
      <section className="directory-hero">
        <div className="directory-hero-content">
          <h1>Directory</h1>
          <p>Contact information for AG&WESTERN Rail Inc. team members</p>
        </div>
      </section>

      {/* Directory Content */}
      <section className="directory-content">
        <div className="directory-container">
          {departments.map((department) => (
            <div key={department.name} className="department-section">
              <h2 className="department-title">{department.name}</h2>
              <div className="employees-list">
                {department.employees.map((employee, index) => (
                  <div key={index} className="employee-card">
                    <h3 className="employee-name">{employee.name}</h3>
                    {employee.title && (
                      <p className="employee-title">{employee.title}</p>
                    )}
                    <div className="employee-contact">
                      <div className="contact-item">
                        <Phone size={18} />
                        <a href={`tel:${employee.phone.replace(/\D/g, '')}`}>
                          {employee.phone}
                        </a>
                      </div>
                      <div className="contact-item">
                        <Mail size={18} />
                        <a href={`mailto:${employee.email}`}>
                          {employee.email}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Directory;
